import { PostHogProvider } from "posthog-js/react";
import * as React from "react";
import { hydrateRoot } from 'react-dom/client';
import { createBrowserRouter, RouteObject, RouterProvider } from 'react-router';
import { LoaderLogo } from './components/Loader/LoaderLogo';
import routes_all from './routes_ssr';

const posthogApiKey = "phc_KBp3Os6czJTZYmROYtVhDxq3nkdeqqD1SBRZJFcOj3J";
const posthogHost = "https://eu.i.posthog.com";
hydrate();

async function hydrate() {
  const router = createBrowserRouter(routes_all as RouteObject[]);
  console.log("AppDev routes_all", routes_all);
  hydrateRoot(
    document.getElementById("root")!,
    <React.StrictMode>

      <PostHogProvider
        apiKey={posthogApiKey || ""}
        options={{
          api_host: posthogHost,
          capture_exceptions: true,
          debug: false,
        }}
      >
        <React.Suspense fallback={<LoaderLogo isLoading />}>
          <RouterProvider router={router} />
        </React.Suspense>
      </PostHogProvider>
    </React.StrictMode>
  );
}